import * as React from "react";
import * as cls from "./WidgetGrid.module.scss";
export { WidgetGrid, WidgetGridModel };
// Минимальный размер экрана для сетки
const MIN_WINDOW_WIDTH = 1440;
/**
 * Сетка для размещения виджетов Личной студии.
 * @param {WidgetGridModel} props - Атрибуты элемента.
 * @returns {JSX.Element} Элемент JSX.
 * @author Алексей Васьковский < avaskovskiy@umney.ru>
 */
function WidgetGrid(props) {
  const [model, updateModel] = React.useState(new WidgetGridModel(props));
  model.load();
  const listener = { onDragStart, onDragOver, onDragEnd };
  return <WidgetGridView model={model} listener={listener} />;
  // Обработка Drag & Drop
  function onDragStart(event) {
    model.drag_id = event.target.closest("." + cls.widget_grid_cell)?.id;
    console.debug("drag", model.drag_id);
    updateModel(new WidgetGridModel(model));
  }
  function onDragOver(event) {
    model.drop_id = findDropTarget(event)?.id;
    console.debug("drag over", model.drag_id, "=>", model.drop_id);
    model.drag_and_drop();
    updateModel(new WidgetGridModel(model));
  }
  function onDragEnd(event) {
    event.preventDefault();
    console.debug("drop", model.drag_id, "=>", model.drop_id);
    model.drag_and_drop();
    model.drag_id = null;
    model.drop_id = null;
    model.save();
    updateModel(new WidgetGridModel(model));
  }
  /**
   * Ищет элемент для drop на его место
   * @param {DragEvent} event
   * @returns {HTMLElement}
   * @private
   */
  function findDropTarget(event) {
    // return event.target.closest("." + cls.widget_grid_cell);

    const target = event.target.closest("." + cls.widget_grid_cell);
    if (!target) return null;
    if (target.id == model.drag_id) return;
    const rect = target.getBoundingClientRect();
    const next = target.nextSibling
      ? target.nextSibling.getBoundingClientRect()
      : null;
    if (
      event.clientX < rect.width / 2 + rect.left ||
      !next ||
      next.top > rect.bottom
    )
      return target;
    else return target.nextSibling;

    // const grid = event.target.closest("." + cls.widget_grid);
    // for (const cell of grid.children) {
    //   const rect = cell.getBoundingClientRect();
    //   if (event.clientX > rect.left && event.clientX < rect.right
    //     && event.clientY > rect.top && event.clientY < rect.bottom) {
    //     console.debug("drop target", cell.id,
    //       rect.left, rect.top, "-", rect.right, rect.bottom,
    //       "at", event.clientX, event.clientY);
    //     return cell;
    //   }
    //   if (cell.nextSibling) {
    //     const next = cell.nextSibling.getBoundingClientRect();
    //     if (event.clientX > rect.right && next.top > rect.bottom
    //       && event.clientY > rect.top && event.clientY < next.top) {
    //       console.debug("drop next", cell.nextSibling.id,
    //         "at", event.clientX, event.clientY);
    //       return cell.nextSibling;
    //     }
    //   }
    // }
    // return null;
  }
}
/**
 * Модель компонента WidgetGrid.
 */
class WidgetGridModel {
  /**
   * Префикс имени для сохранения.
   * @type {string}
   */
  prefix = "";
  /**
   * Идентификатор контракта.
   * @type {int}
   */
  contract_id = 0;
  /**
   * Виджеты.
   * @type {Object.<string, WidgetFrame>}
   */
  widget = {};
  /**
   * Параметры размещения виджетов.
   * @type {Array.<WidgetGridModel~Cell>}
   * @see {@link WidgetGridModel~Cell}
   */
  grid = [];
  /**
   * Обработчик сохранения настроек сетки.
   * @type {function}
   * @default model => { }
   */
  onSave = (model) => {}; // eslint-disable-line no-unused-vars
  /**
   * Копирует свойства объекта.
   * @param {WidgetGridModel} props - Свойства объекта.
   */
  constructor(props) {
    Object.assign(this, props);
  }
  /**
   * @returns {integer} Индекс ячейки по идентификатору виджета.
   * @param {string} id - Идентификатор виджета.
   */
  indexOf(id) {
    for (let i = 0; i < this.grid.length; ++i)
      if (id == this.grid[i].id) return i;
    return -1;
  }
  /**
   * Источник для Drag & Drop.
   * @type {HTMLElement}
   */
  drag_id = null;
  /**
   * Цель для Drag & Drop.
   * @type {HTMLElement}
   */
  drop_id = null;
  /**
   * Выполняет перемещение элемента
   * из {@link WidgetGrid.drag_id} в {@link WidgetGrid.drop_id}.
   */
  drag_and_drop() {
    if (!this.drag_id || !this.drop_id) return;
    if (this.drag_id == this.drop_id) return;
    const source_index = this.indexOf(this.drag_id);
    const target_index = this.indexOf(this.drop_id);
    if (source_index < 0 || target_index < 0) return;
    const source_cell = this.grid[source_index];
    const new_grid = [...this.grid];
    new_grid.splice(source_index, 1);
    new_grid.splice(target_index, 0, source_cell);
    this.grid = new_grid;
  }
  /**
   * @returns {Object} - Данные для сохранения.
   */
  dump() {
    return { grid: this.grid };
  }
  /**
   * Совмещает настройки сетки.
   * @param {WidgetGridModel} data - Сохранённые настройки.
   */
  merge(data) {
    if (data.grid) {
      const default_grid = this.grid;
      this.grid = data.grid.filter((cell) => this.widget[cell.id]);
      for (const cell of default_grid)
        if (this.widget[cell.id]) {
          const i = this.indexOf(cell.id);
          if (i < 0) this.grid.push(cell);
          else {
            this.grid[i].minHeight = cell.minHeight;
            this.grid[i].maxHeight = cell.maxHeight;
          }
        }
    }
  }
  /**
   * Загружает настройки сетки.
   * @private
   */
  load() {
    // const json = localStorage.getItem(
    //   this.prefix + "WidgetGridModel" + this.contract_id);
    // if (!json) return;
    // const data = JSON.parse(json);
    // this.merge(data);
  }
  /**
   * Сохраняет настройки сетки.
   */
  save() {
    // const data = this.dump();
    // const json = JSON.stringify(data);
    // localStorage.setItem(
    //   this.prefix + "WidgetGridModel" + this.contract_id, json);
    this.onSave(this);
  }
}
/**
 * @typedef {Object} WidgetGridModel~Cell
 * @property {string} id - Идентификатор виджета.
 * @property {boolean} visible - Отображать виджет.
 * @property {string|number} [width=auto] - Ширина виджета.
 * @property {string|number} [height=auto] - Высота виджета.
 * @property {string|number} [minHeight] - Минимальная высота виджета.
 * @property {int} [colspan=1] - Количество столбцов, занимаемых в сетке.
 */
/**
 * Вид компонента.
 * @param {Object} props - Атрибуты элемента.
 * @param {WidgetGridModel} props.model - Модель компонента.
 * @param {WidgetGridView~Listener} props.listener - Обработчик событий.
 * @returns {JSX.Element} Элемент JSX.
 */
function WidgetGridView({ model, listener }) {
  const children = model.grid.map((cell) => (
    <WidgetGridCell key={cell.id} cell={cell} model={model} />
  ));
  return (
    <div
      className={cls.widget_grid}
      onDragStart={listener.onDragStart}
      onDragOver={listener.onDragOver}
      onDragEnd={listener.onDragEnd}
    >
      {children}
    </div>
  );
}
/**
 * Обработчик событий WidgetGridView.
 * @typedef {Object} WidgetGridView~Listener
 * @property {function} [onDragStart=event => { }] - Начало Drag & Drop.
 * @property {function} [onDragOver=event => { }] - Обработка Drag & Drop.
 * @property {function} [onDragEnd=event => { }] - Завершение Drag & Drop.
 */
/*
 * Ячейка сетки WidgetGrid.
 * @extends {React.Component}
 */
class WidgetGridCell extends React.Component {
  constructor(props) {
    super(props);
    this.state = { window_width: window.innerWidth };
    this.is_mouse_over = false;
    this.is_mouse_down = false;
    this.ref = React.createRef();
    this.onResize = this.onResize.bind(this);
    this.onWindowResize = this.onWindowResize.bind(this);
    this.observer = new ResizeObserver(this.onResize);
  }
  componentDidMount() {
    this.observer.observe(this.ref.current);
    window.addEventListener("resize", this.onWindowResize);
  }
  componentWillUnmount() {
    this.observer.unobserve(this.ref.current);
    window.removeEventListener("resize", this.onWindowResize);
  }
  /**
   * Обрабатывает изменение размеров ячейки.
   * @param {Array.<ResizeObserverEntry>} entries
   */
  onResize(entries) {
    requestAnimationFrame(() => {
      const { cell, model } = this.props;
      if (this.is_mouse_down && this.is_mouse_over) {
        for (const entry of entries) {
          cell.width = entry.contentRect.width;
          cell.height = entry.contentRect.height;
          const colspan = this.getColSpan(cell.width);
          if (cell.colspan != colspan) {
            cell.colspan = colspan;
            entry.target.style.gridColumnEnd = "span " + cell.colspan;
          }
        }
        model.save();
      }
    });
  }
  onMouseUp(event) {
    this.is_mouse_down = false;
    const target = event.target.closest("." + cls.widget_grid_cell);
    target.style.width = "auto";
  }
  /**
   * Обрабатывает изменение размеров окна.
   */
  onWindowResize() {
    this.setState({ window_width: window.innerWidth });
  }
  /**
   * @returns {int} Количество столбцов для данной ширины ячейки.
   * @param {number} width - Ширина ячейки в пикселях.
   */
  getColSpan(width) {
    if (!this.ref.current) return 1;
    const grid_size = this.ref.current.parentNode.getBoundingClientRect();
    const cell_width = grid_size.width / 3 + 1;
    return Math.min(3, Math.ceil(width / cell_width));
  }
  /**
   * Отображает компонент.
   * @returns {JSX.Element} Элемент JSX.
   */
  render() {
    const { cell, model } = this.props;
    const { window_width } = this.state;
    const draggable = window_width >= MIN_WINDOW_WIDTH ? "true" : undefined;
    const widget = model.widget[cell.id];
    let className = cls.widget_grid_cell;
    if (model.drag_id == cell.id)
      className += " " + cls.widget_grid_cell_dragging;
    const style = {};
    if (!cell.visible) style.display = "none";
    else {
      if (draggable) {
        style.height = cell.height;
        style.gridColumnStart = "auto";
        style.gridColumnEnd = "span " + cell.colspan;
        if (cell.minHeight) style.minHeight = cell.minHeight;
        if (cell.maxHeight) style.maxHeight = cell.maxHeight;
      }
    }
    return (
      <div
        id={cell.id}
        ref={this.ref}
        className={className}
        style={style}
        draggable={draggable}
        onMouseOver={
          (/*event*/) => {
            this.is_mouse_over = true;
          }
        }
        onMouseOut={
          (/*event*/) => {
            this.is_mouse_over = false;
          }
        }
        onMouseDown={
          (/*event*/) => {
            this.is_mouse_down = true;
          }
        }
        onMouseUp={(event) => {
          this.onMouseUp(event);
        }}
      >
        {widget}
      </div>
    );
  }
}
